










import Component from 'vue-class-component';

import { BaseVue } from '../../BaseVue';
import SingleSignon from '../../components/org/Security.vue';
@Component({
  components: {
    SingleSignon,
  },
})
export default class SingleSignonClass extends BaseVue {
  public selectedTab = 0;
}
